import React from 'react'
import { Button } from "primereact/button";

export default function BaseButton(props) {
    return (
        <Button {...props} className={` ${props.extra ? props.extra : ""}  ${props.col ? `p-col-${props.col}` : ""}  ${props.md ? `p-md-${props.md}` : ""}  ${props.sm ? `p-sm-${props.sm}` : ""}  ${props.lg ? `p-lg-${props.lg}` : ""} `} />
    )
}
